var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrowIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.74244C0 7.51433 0.0903001 7.29556 0.251035 7.13426C0.41177 6.97296 0.629774 6.88234 0.857088 6.88234L21.0724 6.88234L15.6779 1.47063C15.5169 1.30913 15.4265 1.09008 15.4265 0.861682C15.4265 0.633282 15.5169 0.414237 15.6779 0.252735C15.8388 0.0912318 16.0571 0.000501131 16.2847 0.000501127C16.5123 0.000501122 16.7306 0.0912318 16.8915 0.252735L23.7482 7.13349C23.828 7.21339 23.8913 7.3083 23.9346 7.41279C23.9778 7.51729 24 7.62931 24 7.74244C24 7.85557 23.9778 7.96759 23.9346 8.07208C23.8913 8.17658 23.828 8.27149 23.7482 8.35139L16.8915 15.2321C16.7306 15.3936 16.5123 15.4844 16.2847 15.4844C16.0571 15.4844 15.8388 15.3936 15.6779 15.2321C15.5169 15.0706 15.4265 14.8516 15.4265 14.6232C15.4265 14.3948 15.5169 14.1757 15.6779 14.0142L21.0724 8.60253H0.857088C0.629774 8.60253 0.41177 8.51191 0.251035 8.35062C0.0903001 8.18932 0 7.97055 0 7.74244V7.74244Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIconWhite);
export default __webpack_public_path__ + "static/media/right-arrow-icon-white.e3a2f94dd8289d3d24bd5f05bc8ffef4.svg";
export { ForwardRef as ReactComponent };